import { combineReducers } from 'redux'
import { TRACK_LOG_PAGE_ERROR, TRACK_LOG_PAGE_LOADING, TRACK_LOG_PAGE_SUCCESS, TRACK_LOG_VIEW_ERROR, TRACK_LOG_VIEW_LOADING, TRACK_LOG_VIEW_SUCCESS } from './constant'

const trackLogPageError = (state = false, action) => {
  switch (action.type) {
    case TRACK_LOG_PAGE_ERROR:
      return action.trackLogPageError
    default:
      return state
  }
}

const trackLogPageLoading = (state = false, action) => {
  switch (action.type) {
    case TRACK_LOG_PAGE_LOADING:
      return action.trackLogPageLoading
    default:
      return state
  }
}

const trackLogPageSuccess = (state = false, action) => {
  switch (action.type) {
    case TRACK_LOG_PAGE_SUCCESS:
      return action.trackLogPageSuccess
    default:
      return state
  }
}

const trackLogs = (state = [], action) => {
  switch (action.type) {
    case TRACK_LOG_PAGE_SUCCESS:
      return action.trackLogs
    default:
      return state
  }
}

const trackLogViewError = (state = false, action) => {
  switch (action.type) {
    case TRACK_LOG_VIEW_ERROR:
      return action.trackLogViewError
    default:
      return state
  }
}

const trackLogViewLoading = (state = false, action) => {
  switch (action.type) {
    case TRACK_LOG_VIEW_LOADING:
      return action.trackLogViewLoading
    default:
      return state
  }
}

const trackLogViewSuccess = (state = false, action) => {
  switch (action.type) {
    case TRACK_LOG_VIEW_SUCCESS:
      return action.trackLogViewSuccess
    default:
      return state
  }
}

const trackLog = (state = [], action) => {
  switch (action.type) {
    case TRACK_LOG_VIEW_SUCCESS:
      return action.trackLog
    default:
      return state
  }
}

const trackLogReducer = combineReducers({
  trackLogPageError,
  trackLogPageLoading,
  trackLogPageSuccess,
  
  trackLogs,
  trackLog,

  trackLogViewError,
  trackLogViewLoading,
  trackLogViewSuccess,
})

export default trackLogReducer
